var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.0006 18.0002H12.0106M9.17262 15.1722C9.92273 14.4224 10.94 14.0011 12.0006 14.0011C13.0613 14.0011 14.0785 14.4224 14.8286 15.1722M6.34363 12.3433C7.0865 11.6004 7.96843 11.0111 8.93907 10.609C9.9097 10.2069 10.95 10 12.0006 10C13.0512 10 14.0916 10.2069 15.0622 10.609C16.0328 11.0111 16.9148 11.6004 17.6576 12.3433M3.51562 9.51525C8.20162 4.82825 15.7996 4.82825 20.5156 9.51525", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});